import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  chatFrames: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'calc(100vh - 40px)',
    padding: '15px 0',
    overflow: 'hidden',
  },

  chatMain: {
    display: 'none',
    width: '0',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: '#fff',
    opacity: '0',
    // margin:"-200px",
  },

  chatMainOpen: {
    width: '450px',
    opacity: '1',
    display: 'block',
    height: 'calc(100vh - 85px)'
  },

  chatTabWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },

  chatIFrames: {
    border: 0,
  },
}));
